<template>
  <div v-if="isLoaded" id="integrationSetting" class="mx-5"> 
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          :height="80"
          :max-width="70"
          :src="require(`@/assets/conectiontab/shopify.png`)"
          class="mr-3"
        />
        <h2 style="line-height:85px;" class="mr-3"> Shopify </h2>
      </div>
      <v-col cols="1">
        <v-btn
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <v-card outlined class="update-card mb-5">
        <v-row class="px-3 pt-3">
          <v-col cols="1">
            <v-icon color="#3FD06F" class="mr-3" style="font-size:35px;"> mdi-checkbox-marked-circle </v-icon>
          </v-col>
          <v-col class="ml-1">
            <v-row><h2>Integration Update</h2> </v-row>
            <v-row class="mt-2 pr-2">
              <p v-if="syncingStatus">
              You just added the Shopify integration. We are syncing the data right now and you should check back in a few minutes. As you continue to use Shopify, we will automatically keep that data in sync with Maropost.
              </p>
              <p v-else>You just added the Shopify integration. As new contacts and orders get created to your Shopify store we will import them into the Maropost list you have selected.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <div>
        <h2>Integration Info</h2>
        <skelton-loader v-if="isListLoading" :is-loading="isListLoading"/>
        <div class="mt-5 py-2 px-3 bg-grey" v-else>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">Shop URL </v-col>
            <v-col class="py-0">{{ storeData.organization_name }}</v-col>
          </v-row>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">Shop Name </v-col>
            <v-col class="py-0">{{ storeData.nick_name }}</v-col>
          </v-row>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">Maropost List</v-col>
            <v-col class="py-0">{{ listName }}</v-col>
          </v-row>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">Status</v-col>
            <v-col class="py-0">
              <v-chip
                small
                outlined
                dark
                class="mt-1 mr-3"
                :color="storeData.active ? '#41CE65': '#FFB933' "
              >
                {{ storeData.active ? 'Active' : 'Processing' }}
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="my-5">
        <h2>Shopify Fields Mapping to Maropost Fields</h2>
        <v-simple-table outlined class="mt-5 field-table">
            <thead class="bg-grey">
              <tr>
                <th class="text-left">Maropost Fields</th>
                <th class="text-left">Shopify Fields</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(field, index) in fields" v-bind:key="index">
                <td :class="{ 'bg-grey': field.shopify == '' }">{{field.maropost}}</td>
                <td :class="{ 'bg-grey': field.shopify == '' }">{{ field.shopify }}</td>
              </tr>
            </tbody>
        </v-simple-table>
      </div>

      <v-btn dark :to="'/accounts/' + $store.getters['auth/account'].id + '/integrations/shopify'" class="mb-5" @click="navigateIndexPage()" id="shopify-store-index"> Done </v-btn>
    </div>
  </div>
</template>

<script>
import  { $integrations } from '@/services'
import isEmpty from 'lodash/isEmpty'
import SkeltonLoader from '@/components/shared/SkeltonLoader.vue'
import IntegrationDetailMixin from '@/mixins/IntegrationDetailMixin.js'

export default {
  name: "ShopifyDetailDrawer",
  components: { SkeltonLoader },
  mixins:[IntegrationDetailMixin],
  data(){
    return{
      fields: [
        {
          maropost: "For Orders",
          shopify: ""
        },
        {
          maropost: "grand_total",
          shopify: "total_price"
        },
        {
          maropost: "original_order_id",
          shopify: "order_number"
        },
        {
          maropost: "order_date",
          shopify: "created_at"
        },
        {
          maropost: "order_status",
          shopify: "financial_status"
        },
        {
          maropost: "For Products",
          shopify: ""
        },
        {
          maropost: "item_id",
          shopify: "variant_id"
        },
        {
          maropost: "quantity",
          shopify: "quantity"
        },
        {
          maropost: "description",
          shopify: "name"
        },
        {
          maropost: "name",
          shopify: "title"
        },
        {
          maropost: "price",
          shopify: "price"
        },
        {
          maropost: "description",
          shopify: "title"
        },
        {
          maropost: "categories",
          shopify: "product_type"
        },
        {
          maropost: "image_url",
          shopify: "image[src]"
        },
        {
          maropost: "status",
          shopify: "status"
        },
        {
          maropost: "brand",
          shopify: "vendor"
        },
        {
          maropost: "published",
          shopify: "published_scope"
        },
        {
          maropost: "availability",
          shopify: "inventory_quantity"
        },
        {
          maropost: "For Contacts",
          shopify: ""
        },
        {
          maropost: "email",
          shopify: "email"
        },
        {
          maropost: "first_name",
          shopify: "first_name"
        },
        {
          maropost: "last_name",
          shopify: "last_name"
        },
        {
          maropost: "phone",
          shopify: "phone"
        },
        {
          maropost: "status",
          shopify: "email_marketing_consent/sms_marketing_consent"
        }
      ],
      storeData: {},
      syncingStatus: true,
      isLoaded: false
    }
  },
  mounted(){
    this.getStoreDetail(this.$store.getters['ui/drawer'].right.crm_id)
  },
  methods:{
    navigateIndexPage(){
      localStorage.removeItem('selected_integration_list_name')
      this.$router.push( { name: 'Shopify_index'})
    },
    editStore(){
      const drawer = this.$store.getters['ui/drawer'].right
      this.$store.commit('ui/drawer.right', {
        component: 'ShopifyIntegrationDrawer',
        show: true,
        width: '700px',
        firstConnection: false,
        editStore: true,
        storeId: this.storeData.id,
        permanent: true
      })
    },
    getStoreDetail(storeId){
      this.isListLoading = true
      $integrations.getStoreDetail('shopify', storeId)
      .then(res => {
        this.storeData = res.data.crm
        if(this.storeData.crm_lists.length == 0){
          this.editStore()
        }
        this.syncingStatus = res.data.sync_old_data || true
        if(!isEmpty(this.storeData.crm_lists)) this.getListDetails(this.storeData.crm_lists[0])
      })
      .catch(error => {
        this.isListLoading = false
        this.$store.commit('ui/snackbar', {
          message: error,
          type: 'error',
        }) 
      })
      .finally(() => {
        this.isLoaded = true;
      })
    }
  },
  computed:{
    listName(){
      return !isEmpty(this.listDetails)?this.listDetails.name: localStorage.getItem('selected_integration_list_name') 
    }
  }
};
</script>

<style scoped>
.bg-grey {
  background-color: #f4f4f4;
}
.update-card{
  border: 1px solid #3BCF6C !important;
}
.field-table{
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
